import React from 'react';
import Image from 'gatsby-image';
import styles from './hero-bg-image.module.css';

const HeroBGImage = ({ heroBGImage }) => {
  return (
    <Image
      sizes={heroBGImage.localFile.childImageSharp.sizes}
      backgroundColor={true}
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
    />
  );
};

export default HeroBGImage;



// WEBPACK FOOTER //
// ./src/components/hero-awkward/hero-bg-image/index.js